import React from 'react';
import Styles from './carrouselItem.module.scss';
import IActualite from 'model/actualite';
import Picture from 'components/common/picture/picture';

interface ICarrouselItemState {
}

interface ICarrouselItemProps {
  actu: IActualite,
}

class CarrouselItem extends React.Component<ICarrouselItemProps, ICarrouselItemState>
{
  /**
   *
   */
  constructor(props: ICarrouselItemProps) {
    super(props);

  }

  render() {
    return <div className={Styles.CarrouselItem}>
      <Picture className="CarrouselPict d-block w-100 h-100" RenditionID={1} PictureUrl={encodeURI(this.props.actu.PictureUrl)}/>
      <div className="CarrouselText">
        <h2>{this.props.actu.Title}</h2>
        <a href={`/#/actualite/${this.props.actu.Id}`}>Voir l'actualité</a>
      </div>
    </div>
  }


}

export default CarrouselItem;
